import { render, staticRenderFns } from "./airApproveSettings.vue?vue&type=template&id=60e9c822&scoped=true&"
import script from "./airApproveSettings.vue?vue&type=script&lang=js&"
export * from "./airApproveSettings.vue?vue&type=script&lang=js&"
import style0 from "./airApproveSettings.vue?vue&type=style&index=0&id=60e9c822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e9c822",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e9c822')) {
      api.createRecord('60e9c822', component.options)
    } else {
      api.reload('60e9c822', component.options)
    }
    module.hot.accept("./airApproveSettings.vue?vue&type=template&id=60e9c822&scoped=true&", function () {
      api.rerender('60e9c822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceAir/components/airApproveSettings.vue"
export default component.exports